function closeConditionPopovers(except) {
  document.querySelectorAll('[data-condition-trigger][aria-expanded="true"]').forEach((button) => {
    if (button !== except) button.setAttribute('aria-expanded', 'false');
  });
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const conditionButton = event.target.closest('[data-condition-trigger]');
  if (conditionButton instanceof HTMLButtonElement) {
    event.preventDefault();
    event.stopPropagation();
    const willOpen = conditionButton.getAttribute('aria-expanded') !== 'true';
    closeConditionPopovers(conditionButton);
    conditionButton.setAttribute('aria-expanded', String(willOpen));
    return;
  }

  closeConditionPopovers();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeConditionPopovers();
});
